import React from 'react';
import { Card } from '../../components/ui/card';

const RideStatusBanner = ({ status, statusMessage }) => {
  const getBannerStyle = () => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-50 border-yellow-200';
      case 'accepted':
        return 'bg-green-50 border-green-200';
      case 'arriving':
        return 'bg-blue-50 border-blue-200';
      case 'in_progress':
        return 'bg-purple-50 border-purple-200';
      case 'completed':
        return 'bg-gray-50 border-gray-200';
      default:
        return 'bg-gray-50';
    }
  };

  const getDotColor = () => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-500';
      case 'accepted':
        return 'bg-green-500';
      case 'arriving':
        return 'bg-blue-500';
      case 'in_progress':
        return 'bg-purple-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusDescription = () => {
    switch (status) {
      case 'pending':
        return 'Please wait while we find you a driver...';
      case 'accepted':
        return 'Your driver is on the way to pick you up!';
      case 'arriving':
        return 'Your driver is almost at the pickup point!';
      case 'in_progress':
        return 'You are on your way to your destination!';
      case 'completed':
        return 'Thank you for riding with Tekstar!';
      default:
        return '';
    }
  };

  return (
    <Card className={`p-4 ${getBannerStyle()}`}>
      <div className="flex items-center gap-3">
        <div className={`w-3 h-3 rounded-full animate-pulse ${getDotColor()}`}></div>
        <div className="flex-1">
          <p className="font-semibold text-gray-900">{statusMessage}</p>
          <p className="text-sm text-gray-600">{getStatusDescription()}</p>
        </div>
      </div>
    </Card>
  );
};

export default RideStatusBanner;
